export default function nextTick(fn, ms = 0) {
  return new Promise((resolve) => {
    setTimeout(function () {
      typeof fn === 'function' && fn()
      resolve()
    }, ms)
  })
}
